import { useRef } from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import { IconContainer } from 'components/atoms/Icons'
import InCardStack from 'components/atoms/container/InCardStack'
import { useTranslation } from 'react-i18next'
import ProfileAvatar from 'components/atoms/ProfileAvatar'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import AddIcon from '@mui/icons-material/Add'
import { ActionText } from 'components/atoms/Text'

const ProfileAvatarSection = ({ user, profileImage, uploadImage }) => {
  const { t } = useTranslation()
  const imageInputRef = useRef(null)
  const handleUploadClick = () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = null // Reset the input value to allow re-uploading the same file
      imageInputRef.current.click()
    }
  }
  return (
    <InCardStack spacing={4}>
      <input
        ref={imageInputRef}
        accept='image/*'
        hidden
        type='file'
        onChange={uploadImage}
      />
      <Box
        sx={{
          position: 'relative'
        }}>
        <ProfileAvatar
          user={user}
          newImage={profileImage}
          size={140}
          fontSize={50}
        />
        <IconButton
          sx={{
            backgroundColor: 'secondary.dark',
            borderRadius: 25,
            width: 40,
            height: 40,
            position: 'absolute',
            bottom: 0,
            right: 0,
            '&:hover': {
              backgroundColor: 'secondary.light'
            }
          }}
          onClick={() => handleUploadClick()}>
          <IconContainer
            icon={profileImage ? <EditOutlinedIcon /> : <AddIcon />}
          />
        </IconButton>
      </Box>
      {profileImage && (
        <ActionText variant='body1Small' onClick={uploadImage}>
          {t('profile.removePhoto')}
        </ActionText>
      )}
      <Typography
        variant='body1Micro'
        color='textSecondary'
        textAlign='center'
        width={140}>
        {t('onboarding.recommendedSize')}
      </Typography>
    </InCardStack>
  )
}

export default ProfileAvatarSection
